module.exports = __webpack_public_path__ + "img/wb.4076f06d.png";